export class QuoteDetailQueryParameters {
  addedByPowerlane?: string;
  associateId?: string;
  campaignNumber?: string;
  createdFromSourceReference?: string;
  createdFromSourceType?: string;
  customerActioned?: boolean;
  embed?: any;
  employeeId?: string;
  excludeDeleted?: boolean;
  excludeExpired?: boolean;
  excludeFromVcr?: string;
  id?: string;
  labourOpCode?: string;
  opCode?: string;
  page?: number;
  pageSize?: number;
  partKitsMaintenanceId?: string;
  rooftopId?: string;
  quoteHeaderId?: string;
  sequence?: string;
  serviceGroupId?: string;
  technicianId?: string;
  technicianGroupId?: string;
  transactionTypeId?: string;
  warrantySubmissionTypeId?: string;
  workHeaderId?: string;

  constructor(obj?: QuoteDetailQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class QuoteToServiceAppointmentQueryParameters {
  appointmentId: number;
  counter: number;
  quoteDetailSequence: number;
  quoteHeaderId: number;

  constructor(obj?: QuoteToServiceAppointmentQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
